var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", {
    attrs: { hideable: true },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h4", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.resource("IOFormat_Index_SubHeading_Create")) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "single-column-grid" },
              [
                _c(
                  "base-format",
                  {
                    ref: "formatBase",
                    staticClass: "grid-container",
                    attrs: {
                      type: _vm.type,
                      name: _vm.model.name,
                      isExport: _vm.model.isExport,
                      isImport: _vm.model.isImport
                    },
                    on: {
                      "update:name": function($event) {
                        return _vm.$set(_vm.model, "name", $event)
                      },
                      "update:isExport": function($event) {
                        return _vm.$set(_vm.model, "isExport", $event)
                      },
                      "update:is-export": function($event) {
                        return _vm.$set(_vm.model, "isExport", $event)
                      },
                      "update:isImport": function($event) {
                        return _vm.$set(_vm.model, "isImport", $event)
                      },
                      "update:is-import": function($event) {
                        return _vm.$set(_vm.model, "isImport", $event)
                      },
                      valid: function($event) {
                        _vm.baseValid = $event
                      }
                    }
                  },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.resource("IOFormatListViewModel_Type_DisplayName")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-select",
                      {
                        staticClass: "form-control",
                        attrs: {
                          options: _vm.types,
                          disabled: _vm.types.length === 0,
                          clearable: false
                        },
                        model: {
                          value: _vm.type,
                          callback: function($$v) {
                            _vm.type = $$v
                          },
                          expression: "type"
                        }
                      },
                      [
                        _c("div", {
                          attrs: { slot: "no-options" },
                          slot: "no-options"
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isEntity
                  ? _c("entity-format", {
                      staticClass: "grid-container",
                      on: {
                        valid: function($event) {
                          _vm.entityValid = $event
                        }
                      },
                      model: {
                        value: _vm.attributes,
                        callback: function($$v) {
                          _vm.attributes = $$v
                        },
                        expression: "attributes"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCsv
                  ? _c("csv-format", {
                      staticClass: "grid-container",
                      attrs: {
                        file: _vm.model.csvFile,
                        separator: _vm.model.separator
                      },
                      on: {
                        "update:file": function($event) {
                          return _vm.$set(_vm.model, "csvFile", $event)
                        },
                        "update:separator": function($event) {
                          return _vm.$set(_vm.model, "separator", $event)
                        },
                        valid: function($event) {
                          _vm.csvValid = $event
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "grid-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: !_vm.valid },
                      on: { click: _vm.createFormat }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.resource("IOFormat_Index_Submit_Create_Button")
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }